import React, { Component } from 'react'
import { connect } from 'react-redux'
import './dietStyle.css'

class DietStyle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedOption: props.dietStyle || '',
    }
  }

  componentDidMount() {
    this.setState({
      selectedOption: this.props.dietStyle || '',
    })
  }
  handleSelect = (option) => {
    this.setState({ selectedOption: option }, () => {
      this.props.selectDietStyle(option)
    })
  }
  selectCantidadComida = (option) => {
    this.props.selectCantidadComida(option)
  }

  render() {
    const { selectedOption } = this.state
    const options = [
      {
        value: 1,
        title: 'Muy baja en carbohidratos (Keto / Cetogénica)',
      },
      {
        value: 2,
        title: 'Baja en carbohidratos (Low Carb)',
      },
      {
        value: 3,
        title: 'Moderada en carbohidratos (Balanceada)',
      },
    ]
    return (
      <div className="container alimentation-type">
        <div className="row">
          <div className="section-text__allergies col-md-12 col-lg-6">
            Estilo de dieta
          </div>

          <div className="options col-md-12 col-lg-6">
            <p>
              Selecciona el estilo de dieta que llevas y haz clic en
              <strong> siguiente</strong>
            </p>

            <div className="alimentacion-container dietStyle">
              {options.map((option) => (
                <label
                  key={option.value}
                  className={`option-card dietStyle ${
                    selectedOption === option.value ? 'selected' : ''
                  }`}
                  onClick={() => this.handleSelect(option.value)}
                >
                  <input
                    type="radio"
                    name="alimentacion"
                    value={option.value}
                    checked={selectedOption === option.value}
                    onChange={() => this.handleSelect(option.value)}
                  />
                  <div className="option-title">{option.title}</div>
                </label>
              ))}
            </div>
            <div className="comidas-section">
              <p>Elige la cantidad de comidas que haces al día</p>
              <div className="comidas-container">
                {Array.from({ length: 5 }, (_, index) => index + 1).map(
                  (option) => (
                    <div
                      className={`comidas-option ${
                        option === this.props.cantidadComidas ? 'selected' : ''
                      }`}
                      onClick={() => this.selectCantidadComida(option)}
                    >
                      {option}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  dietStyle: state.dietStyle,
  cantidadComidas: state.cantidadComidas,
})

const mapDispatchToProps = (dispatch) => ({
  selectDietStyle(option) {
    dispatch({
      type: 'SELECT_DIET_STYLE',
      dietStyle: option,
    })
  },
  selectCantidadComida(option) {
    dispatch({
      type: 'SELECT_CANTIDAD_COMIDAS',
      cantidadComidas: option,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DietStyle)
